<script lang="ts">
	//UI
	import { DefaultDone, TextSwitch } from "@hitit/new_ui";
	//Image
	import closeBtn from "@hitit/hub/src/assets/Icons/closeBtn.png";
	//Utils
	import { t, api } from "@hitit/hub/src/stores";
	import { addSpacer } from "@hitit/hub/src/functions/utils/phone";
	import { formatKoreanRegistrationNumberHandler } from "@hitit/hub/src/v7/utils";
	import type {
		CashReceiptResponse,
		CashReceiptTransactionDTO,
		PaymentData,
		PaymentTransactionData,
	} from "@hitit/api";

	export let cashReceiptModal = false;
	export let cashReceiptModalData: MergePaymentDatas;
	export let loadPayments: () => void;
	interface MergePaymentDatas extends PaymentData {
		cashReceiptResponse?: CashReceiptResponse;
	}

	let step = 1;
	let paymentTransactionDTO: PaymentTransactionData;
	let buisnessman = false;
	let phoneNumber = "";
	let registrationNumber = "";
	let postTransactionDTO: CashReceiptTransactionDTO;

	function flatPayment() {
		if (cashReceiptModalData && cashReceiptModalData.paymentTransactionDTOs) {
			paymentTransactionDTO = cashReceiptModalData.paymentTransactionDTOs[0];
		}
		// 현금영수증 발급할때 필요한 DTO
		postTransactionDTO = {
			storeId: cashReceiptModalData.storeId,
			paymentId: cashReceiptModalData.id!,
			identityNum: "",
			serviceFee: "0",
			supplyCost: String(
				paymentTransactionDTO.totalReceivedPrice -
					paymentTransactionDTO.totalReceivedTax
			),
			tradeType: "REGISTER",
			tradeUsage: "",
			tradeOpt: "ILBAN",
			taxationType:
				paymentTransactionDTO.totalReceivedTax === 0 ? "TAXFREE" : "TAXABLE",
			totalAmount: String(paymentTransactionDTO.totalReceivedPrice),
			tax: String(paymentTransactionDTO.totalReceivedTax),
		};
	}

	function createCatResponse(cashReceipt: CashReceiptResponse) {
		let transactionUUID = cashReceipt.cashReceiptTransactionIssue.id ?? "";
		if (cashReceipt.cashReceiptTransactionCancel) {
			transactionUUID = cashReceipt.cashReceiptTransactionCancel.id ?? "";
		}
		const catResponseDTO = {
			catModel: "HITIT_CASH_RECEIPT_API",
			terminalId: "web",
			authorizationID: cashReceipt.id,
			transactionAuthorizationTime:
				cashReceipt.cashReceiptTransactionIssue.tradeDate ?? "",
			cardCompany: cashReceipt.cashReceiptTransactionIssue.tradeUsage ?? "",
			storeCode: "",
			acquirerName: "",
			responseMessage1:
				cashReceipt.cashReceiptTransactionIssue.confirmNum ?? "",
			responseMessage2: "",
			processType: cashReceipt.cashReceiptTransactionIssue.taxationType ?? "",
			maskedCardNumber:
				cashReceipt.cashReceiptTransactionIssue.identityNum ?? "",
			storeID: cashReceipt.cashReceiptTransactionIssue.storeId ?? "",
			transactionUUID: transactionUUID,
			installment: paymentTransactionDTO.catResponseDTO?.installment ?? "",
			totalAmount: String(paymentTransactionDTO.totalReceivedPrice),
			taxedAmount: String(paymentTransactionDTO.totalTaxablePrice ?? 0),
			taxFreeAmount: String(paymentTransactionDTO.totalTaxFreePrice ?? 0),
			tip: paymentTransactionDTO.catResponseDTO?.tip ?? "",
			tax: String(paymentTransactionDTO.totalReceivedTax ?? 0),
			transactionType: cashReceipt.cashReceiptTransactionIssue.tradeType ?? "",
			catResponseType: "CASH_RECEIPT",
			sourceIp: paymentTransactionDTO.catResponseDTO?.sourceIp ?? "",
			destinationIp: paymentTransactionDTO.catResponseDTO?.destinationIp ?? "",
		};
		return catResponseDTO;
	}

	function modalCloseHandler() {
		cashReceiptModal = false;
		document.body.style.overflow = "unset";
		document.body.style.touchAction = "unset";
	}

	function inputChangeHandler(e: Event) {
		const target = e.currentTarget as HTMLInputElement;
		const { value } = target;
		const replace = value
			.replace(/-/g, "") //"-"제거
			.replace(/[^0-9]/g, ""); //숫자를제거한 나머지 모두 제거
		const newValue = addSpacer(replace);
		target.value = newValue;
		phoneNumber = replace;
	}

	function idChangeHandler(_: HTMLElement, replacedValue: string) {
		if (registrationNumber.length > 10) return;
		registrationNumber = replacedValue;
	}

	async function issuanceHandler() {
		try {
			if (buisnessman && registrationNumber.length === 0) {
				registrationNumberError = true;
				return;
			}
			if (buisnessman === false && phoneNumber.length === 0) {
				phoneNumberError = true;
				return;
			}
			postTransactionDTO.identityNum = buisnessman
				? registrationNumber
				: phoneNumber;
			postTransactionDTO.tradeUsage = buisnessman
				? "JICHUL_JEUNGBING"
				: "SODEK_GONGJAE";

			const r = await $api.postCashReceipt(
				postTransactionDTO as CashReceiptTransactionDTO
			);
			const createdcatResponseDTO = createCatResponse(r.data);
			console.log("createdcatResponseDTO",createdcatResponseDTO)
			if (cashReceiptModalData && cashReceiptModalData.paymentTransactionDTOs) {
				const {
					mclientVersion,
					mdeviceType,
					mdeviceUUID,
					...putPaymentTransactionDTO
				} = paymentTransactionDTO;
				console.log("putPaymentTransactionDTO", putPaymentTransactionDTO);

				await $api.putCashReceiptWithPaymentTransaction(
					cashReceiptModalData.id!,
					paymentTransactionDTO.id!,
					{ ...putPaymentTransactionDTO, catResponseDTO: createdcatResponseDTO }
				);
			}
			loadPayments();
			step = 2;
		} catch (e) {
			console.log(e);
			const errorMessage = e?.response?.data?.message || e?.message || "현금영수증 발행 중 오류가 발생했습니다.";
      alert(`발행 실패: ${errorMessage}`);
		}
	}

	// cancelHandler는 잘동작함. 다만 앱의 경우 현금영수증 취소 후 결제취소까지 자동으로 취소됨(결국 앱은 현금영수증 단독취소가 없다는뜻)
	// 대표님께서 이 기능은 웹에서 굳이 있어야할 필요가 없다고 하심 26.07.21
	async function cancelHandler() {
		try {
			const cancelCashReceiptDTO = {
				cashreceiptId: cashReceiptModalData.cashReceiptResponse?.id || "",
				cancelType: 0,
			};
			const r = await $api.postCancelCashReceipt(cancelCashReceiptDTO);
			const { cashReceiptTransactionCancel } = r.data;
			
			const dataId = r.data.id;
			const uuid = cashReceiptTransactionCancel.id;
			const {
				mclientVersion,
				mdeviceType,
				mdeviceUUID,
				createdDate,
				id,
				...flatPaymentTransactionDTO
			} = paymentTransactionDTO;

			delete flatPaymentTransactionDTO.catResponseDTO!.log;
			// 여기서 취소 데이터를 transaction catresponse에 담아준다(flatPaymentTransactionDTO)
			flatPaymentTransactionDTO.catResponseDTO!.acquirerName = "";
			flatPaymentTransactionDTO.catResponseDTO!.responseMessage2 = "";
			flatPaymentTransactionDTO.catResponseDTO!.storeCode = "";
			flatPaymentTransactionDTO.catResponseDTO!.terminalId = "web";
			flatPaymentTransactionDTO.catResponseDTO!.authorizationID = dataId;
			flatPaymentTransactionDTO.catResponseDTO!.transactionUUID = uuid;
			flatPaymentTransactionDTO.catResponseDTO!.destinationIp = "";
			flatPaymentTransactionDTO.catResponseDTO!.sourceIp = "";
			flatPaymentTransactionDTO.catResponseDTO!.transactionType = "CANCEL";
			flatPaymentTransactionDTO.catResponseDTO!.catResponseType =
				"CASH_CANCEL_RECEIPT";
			// 기존 
			flatPaymentTransactionDTO.paymentTransactionType = "REQUEST_REFUND"

			const transactionResponse = await $api.postTransactions(
        paymentTransactionDTO.paymentId,
        flatPaymentTransactionDTO
      );

			if (
        transactionResponse.data?.status === "WRONG_FORMAT" || 
        transactionResponse.data?.paymentTransactionDTO === null
      ) {
        
        const failMessage = transactionResponse.data?.message || "트랜잭션 등록 형식이 잘못되었습니다 (WRONG_FORMAT).";
        throw new Error(failMessage);
      }

			alert("현금영수증 발행이 취소되었습니다.");
      loadPayments();
      modalCloseHandler();
		} catch (e) {
			console.error("cancelHandler Error: ", e);
			const errorMessage = e?.response?.data?.message || e?.message || "현금영수증 취소 중 오류가 발생했습니다.";
      alert(`취소 실패: ${errorMessage}`);
		}
	}

	function checkIssuanceType() {
		return (
			cashReceiptModalData.cashReceiptResponse?.cashReceiptTransactionIssue
				.identityNum.length === 11
		);
	}

	$: console.log("cashReceiptModalData", cashReceiptModalData);
	// $: console.log("paymentTransactionDTO", paymentTransactionDTO);
	$: flatPayment();
	$: phoneNumberError = phoneNumber.length > 0 && phoneNumber.length < 11;
	$: registrationNumberError =
		registrationNumber.length > 0 && registrationNumber.length < 10;
</script>

<div class="modal-background" t-id="CashReceiptModal">
	{#if cashReceiptModalData.cashReceiptStatus === "UNKNOWN" || cashReceiptModalData.cashReceiptStatus === "CASH_RECEIPT_CANCELED"}
		{#if step === 1}
			<div class="step-one modal">
				<img
					class="modal-close"
					src={closeBtn}
					alt="close"
					on:click={modalCloseHandler}
				/>
				<span class="title"
					>{$t("hub.order.cash_receipt.cash_receipt_issuance")}</span
				>
				<TextSwitch
					bind:toggle={buisnessman}
					firstText={"개인"}
					secondText={"사업자"}
				/>
				{#if buisnessman}
					<span class="number-box">{$t("hub.store.ko_registration.id")}</span>
					<div class="input-box">
						<input
							on:input={(e) =>
								formatKoreanRegistrationNumberHandler(e, idChangeHandler)}
							maxlength="12"
						/>
						<img
							src={closeBtn}
							on:click={() => (registrationNumber = "")}
							alt="close"
						/>
					</div>
					{#if registrationNumberError}
						<span class="input-error"
							>{$t("hub.order.incorrectly_formatted_business_number")}</span
						>
					{/if}
				{:else}
					<span class="number-box">{$t("hub.store.storeinfo.phonenumber")}</span
					>
					<div class="input-box">
						<input
							bind:value={phoneNumber}
							on:input={inputChangeHandler}
							maxlength="13"
						/>
						<img
							src={closeBtn}
							on:click={() => (phoneNumber = "")}
							alt="close"
						/>
					</div>
					{#if phoneNumberError}
						<span class="input-error"
							>{$t("hub.order.incorrectly_formatted_phone_number")}</span
						>
					{/if}
				{/if}
				<div class="issuance-btn" on:click={issuanceHandler}>
					<span>발행</span>
				</div>
			</div>
		{:else}
			<div class="step-two modal">
				<img
					class="modal-close"
					src={closeBtn}
					alt="close"
					on:click={modalCloseHandler}
				/>
				<span class="title"
					>{$t("hub.order.cash_receipt.cash_receipt_issuance_completed")}</span
				>
				<div class="animation-box">
					<DefaultDone color={"#000000"} circleBackground={"#e5e6ec"} />
				</div>
				<div class="contents-wrapper">
					<div class="left-box">
						<span class="box-title"
							>{$t("hub.order.cash_receipt.issuance_type")}</span
						>
						<span class="box-content">{buisnessman ? "사업자" : "개인"}</span>
					</div>
					<div class="right-box">
						<span class="box-title"
							>{buisnessman ? "사업자 번호" : "전화번호"}</span
						>
						<span class="box-content"
							>{buisnessman ? registrationNumber : phoneNumber}</span
						>
					</div>
				</div>
				<div class="issuance-btn" on:click={modalCloseHandler}>
					<span>{$t("global.ok")}</span>
				</div>
			</div>
		{/if}
	{:else if cashReceiptModalData.cashReceiptStatus === "CASH_RECEIPT_ISSUED"}
		<div class="step-one modal">
			<img
				class="modal-close"
				src={closeBtn}
				alt="close"
				on:click={modalCloseHandler}
			/>
			<span class="title"
				>{$t("hub.order.cash_receipt.cash_receipt_issuance")}</span
			>
			<div class="contents-wrapper">
				<div class="left-box">
					<span class="box-title"
						>{$t("hub.order.cash_receipt.issuance_type")}</span
					>
					<span class="box-content"
						>{checkIssuanceType() ? "개인" : "사업자"}</span
					>
				</div>
				<div class="right-box">
					<span class="box-title"
						>{checkIssuanceType() ? "전화번호" : "사업자 번호"}</span
					>
					<span class="box-content"
						>{cashReceiptModalData.cashReceiptResponse
							?.cashReceiptTransactionIssue.identityNum}</span
					>
				</div>
			</div>
			<div class="cancel-btn" on:click={cancelHandler}>
				<span>발행 취소</span>
			</div>
		</div>
	{/if}
</div>

<style lang="scss">
	@import "../../../variables.scss";
	.modal-background {
		position: fixed;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		width: 100vw;
		height: 100vh;
		background: rgba(70, 71, 75, 0.7);
		z-index: 10;
	}

	.modal {
		position: absolute;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		margin: auto;
		background-color: white;
		border-radius: 5px;

		.modal-close {
			position: absolute;
			top: -40px;
			right: 0px;
			width: 30px;
			height: 30px;
			cursor: pointer;
		}
	}
	.step-one {
		display: flex;
		flex-direction: column;
		align-items: baseline;
		width: 320px;
		height: fit-content;
		max-height: 262px;
		padding: 20px 10px;

		.title {
			@include appleAdjustTextForSize(20);
			font-weight: 500;
			color: #46474b;
			margin-bottom: 30px;
		}

		.number-box {
			margin-top: 20px;
			margin-right: auto;
		}

		.input-box {
			display: flex;
			align-items: center;
			width: 300px;
			height: 40px;
			background-color: #f0f0f4;
			border-radius: 5px;
			margin-top: 10px;
			padding-right: 20px;
			input {
				all: unset;
				width: 100%;
				@include appleAdjustTextForSize(16);
				padding: 0px 10px;
			}
			img {
				width: 15px;
				height: 15px;
				cursor: pointer;
			}
		}
		.input-error {
			@include appleAdjustTextForSize(14);
			color: red;
			margin-right: auto;
		}
	}
	.issuance-btn {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
		height: 40px;
		min-height: 40px;
		border-radius: 5px;
		background-color: #6591fa;
		margin-top: 20px;
		cursor: pointer;

		span {
			color: white;
		}
	}

	.contents-wrapper {
		display: flex;
		justify-content: flex-start;
		width: 100%;

		div {
			display: flex;
			flex-direction: column;
			gap: 10px;
		}
		.left-box {
			width: 50%;
		}
		.right-box {
			width: 50%;
		}
	}

	.cancel-btn {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
		height: 40px;
		min-height: 40px;
		border-radius: 5px;
		background-color: #f66d6c;
		margin-top: 20px;
		cursor: pointer;

		span {
			color: white;
		}
	}
	.step-two {
		width: 320px;
		height: 280px;
		padding: 20px 15px;

		.title {
			@include appleAdjustTextForSize(20);
			font-weight: 500;
			color: #46474b;
			margin-bottom: 30px;
		}

		.animation-box {
			width: 83px;
			height: 79px;
			margin-bottom: 20px;
		}

		.box-title {
			@include appleAdjustTextForSize(16);
			color: #6d6f76;
		}
		.box-content {
			@include appleAdjustTextForSize(16);
			font-weight: 400;
			color: #46474b;
		}
	}
	@include DesktopSize {

		.modal {
			.modal-close {
				top: 0;
				right: -60px;
				width: 40px;
				height: 40px;
			}
		}
		.step-one {
			width: 340px;
			max-height: 285px;
			padding: 30px;

			.title {
				@include appleAdjustTextForSize(16, false);
			}
			.input-box {
				width: 330px;
				padding-right: 10px;
				input {
					@include appleAdjustTextForSize(16, false);
				}
			}
			.input-error {
				@include appleAdjustTextForSize(14, false);
			}
		}
		.step-two {
			width: 350px;
			padding: 30px;

			.title {
				@include appleAdjustTextForSize(16, false);
			}
			.box-title {
				@include appleAdjustTextForSize(16, false);
			}
			.box-content {
				@include appleAdjustTextForSize(16, false);
			}
		}
	}
</style>
